import CloseIcon from "@mui/icons-material/Close";
import { Box, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import FormikForm from "../FormikForm";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function CustomModel({
  title,
  allFields,
  isEditModel,
  setisEditModel,
  buttonTitle,
  textbutton,
  formMethod,
  onSuccessModelClose,
  setSelectedRowData,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedRowData && setSelectedRowData("");
    setisEditModel && setisEditModel(false);
  };

  useEffect(() => {
    isEditModel && handleClickOpen();
  }, [isEditModel]);

  useEffect(() => {
    handleClose();
  }, [onSuccessModelClose]);

  return (
    <Box>
      <Button
        size={"large"}
        variant={textbutton ? "text" : "contained"}
        fullWidth={textbutton ? false : true}
        sx={{
          padding: textbutton ? "0px " : "16.5px 14px;",
          textTransform: "capitalize",
        }}
        color="secondary"
        onClick={handleClickOpen}
      >
        {title}
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>

        <Tooltip title="Close" arrow>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>

        <DialogContent dividers sx={{ minWidth: 400, maxWidth: 600 }}>
          <FormikForm
            allFields={allFields}
            isEditModel={isEditModel}
            buttonTitle={buttonTitle}
            formMethod={formMethod}
          />
        </DialogContent>
      </BootstrapDialog>
    </Box>
  );
}
